var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 26,
    height: 26,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.54677,117.72077c-8.64631,0 -16.58477,-3.01662 -22.11523,-6.31769l-3.82369,13.502c5.10046,3.44662 14.34215,6.03323 23.27292,6.31769v12.65523h11.31231v-13.52185c15.59246,-2.58662 23.95431,-13.35646 23.95431,-25.56846c0,-12.78092 -7.09169,-20.54077 -22.962,-26.574c-12.04662,-4.88215 -17.15369,-8.18985 -17.15369,-14.07754c0,-4.88215 3.54585,-10.05538 13.46892,-10.05538c9.63862,0 15.87031,3.30769 19.27723,4.88215l3.83031,-13.21092c-4.53815,-2.30215 -10.63092,-4.45215 -19.56169,-4.74323v-12.89338h-11.62323v13.62108c-14.31569,2.58662 -22.82308,12.06646 -22.82308,24.424c0,13.35646 9.63862,20.24969 24.52323,25.70738c10.492,3.87662 15.45354,8.04431 15.45354,14.50754c-0.00662,6.89985 -6.106,11.34538 -15.03015,11.34538z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.57281f2b.svg";
export { ForwardRef as ReactComponent };